import StoryblokVue from 'storyblok-vue';
import Vue from 'vue';

Vue.use(StoryblokVue);